import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared/shared.module';
import { PresenceComponent, MultiLoginComponent } from './components';

@NgModule({
  declarations: [PresenceComponent, MultiLoginComponent],
  imports: [SharedModule],
  exports: [PresenceComponent],
})
export class PresenceModule {}
